import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getOrganizationProjects } from "../services/projectService";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import { ProjectsResponse } from "./useInternalProjects";
import { resetProjectStatus } from "../store/projectsQuery";

const initialData: ProjectsResponse = {
    totalProjects: 0,
    projects: [],
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
    totalPages: 0,
    limit: 0,
};

const useExternalProjects = () => {
    const dispatch = useAppDispatch()
    const projectQuery = useAppSelector((state) => state.projectsQuery);

const location = useLocation()
    const query = useInfiniteQuery<ProjectsResponse, Error>({
        queryKey: ['external-projects', projectQuery],
        initialPageParam: 1,
        refetchOnReconnect: 'always',
        queryFn: ({ pageParam = 1 }) => getOrganizationProjects<ProjectsResponse>({ 
            params: {
                searchFields: projectQuery.searchFields ? projectQuery.searchFields.map(({ filterName }) => filterName).join(',') : undefined,
                searchValue: projectQuery.searchFields ? projectQuery.searchFields.map(({ filterValue }) => filterValue).join(',') : undefined,
                projectStatuses: projectQuery.projectStatus ? projectQuery.projectStatus?.join(',') : undefined,
                page: pageParam,
                limit: projectQuery.limit,
                inspectionTypeId: projectQuery.inspectionTypeId,
                startDate: projectQuery.startDate,
                endDate: projectQuery.endDate,
            }
        }),
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.nextPage ? allPages.length + 1 : undefined;
        },
        initialData: {
            pages: [initialData],
            pageParams: [undefined],
        },
    });

    useEffect(() => {
        query.refetch();

        // eslint-disable-next-line
    }, [projectQuery]);

    useEffect(() => {
        if (projectQuery.projectStatus) dispatch(resetProjectStatus())

        // eslint-disable-next-line
    }, [location.pathname])

    return query;
};
 
export default useExternalProjects;